import i18n from 'common/i18n';

export const MRC_TEMPLATES = [
	{
		value: '13192908',
		label: i18n.t('Unifon MRC - Privat - Bedrift'),
	},
	{
		value: '13207492',
		label: i18n.t('Unifon MRC - Bedrift - Bedrift'),
	},
	{
		value: '13207476',
		label: i18n.t('Unifon MRC - Bedrift - Privat'),
	},
	{
		value: '13207182',
		label: i18n.t('Unifon MRC - Privat - Privat'),
	},
];

export const MRC_COLUMNS = [
	{key: 'phone_number', title: i18n.t('Mobile'), sortable: true, width: 150},
	{key: 'mrc_signed_at', title: i18n.t('Signed'), sortable: true, width: 120},
	{key: 'mrc_rejected_at', title: i18n.t('Rejected'), sortable: true, width: 120},
	{key: 'mrc_sent_at', title: i18n.t('SMS sent'), sortable: true, width: 120},
	{key: 'process', title: i18n.t('Process %'), sortable: true, width: 100},
	{key: 'avg_time_to_sign', title: i18n.t('Avg time to sign'), sortable: true, width: 150},
	{
		key: 'action',
		title: i18n.t('Action'),
		sortable: false,
		width: 60,
		action: true,
	},
];

export const MRC_TABLE_LIMIT = 20;

export const MRC_FIELDS_COL_ONE = [
	{
		key: 'from_company_name',
		label: i18n.t('From company name'),
		formatText: true,
	},
	{
		key: 'from_vat_no',
		label: i18n.t('From VAT number'),
		formatText: false,
	},
	{
		key: 'from_person_name',
		label: i18n.t('From person name'),
		formatText: true,
	},
	{
		key: 'from_birth_date',
		label: i18n.t('From birth date'),
		formatText: false,
		isDate: true,
	},
];

export const MRC_FIELDS_COL_TWO = [
	{
		key: 'to_company_name',
		label: i18n.t('To company name'),
		formatText: true,
	},
	{
		key: 'to_vat_no',
		label: i18n.t('To VAT number'),
		formatText: false,
	},
	{
		key: 'to_person_name',
		label: i18n.t('To person name'),
		formatText: true,
	},
	{
		key: 'to_birth_date',
		label: i18n.t('To birth date'),
		formatText: false,
		isDate: true,
	},
];